module.exports = __webpack_public_path__ + "img/sv3on.b4484b97.svg";